module.exports = __webpack_public_path__ + "img/edit-dent-red.437c1c33.svg";